import {
  AllocatePlaceholderEventRequest,
  TicketGroup,
} from 'src/WebApiController';

import { EventSearchResult } from '../EventSearch';

export const calculateTicketCountByPosId = (ticketGroups: TicketGroup[]) => {
  const counts = new Map<string, number>();

  ticketGroups.forEach((ticketGroup) => {
    const currentCount = counts.get(ticketGroup.posEvId) ?? 0;
    const countOfTicketGroup = ticketGroup?.ticketCnt ?? 0;
    counts.set(ticketGroup.posEvId, currentCount + countOfTicketGroup);
  });
  return counts;
};

export const matchUpPlaceholderEventsAndCatalogEvents = (
  catalogEvents: EventSearchResult[],
  posEventIdsToAllocate: string[]
) => {
  const sortedCatalogEvents = catalogEvents.toSorted((a, b) => {
    const startDateA = new Date(a.event.dates.start ?? '');
    const startDateB = new Date(b.event.dates.start ?? '');
    if (startDateA.valueOf() === startDateB.valueOf()) return 0;
    return startDateA.valueOf() < startDateB.valueOf() ? 1 : -1;
  });

  return posEventIdsToAllocate.reduce(
    (results, next, nextIndex): AllocatePlaceholderEventRequest[] => {
      if (
        !sortedCatalogEvents[nextIndex]?.event.viagId ||
        !sortedCatalogEvents[nextIndex]?.event.dates.start
      ) {
        return results;
      }
      return [
        ...results,
        {
          posEventId: next,
          viagogoEventId: sortedCatalogEvents[nextIndex].event.viagId,
          eventDateTime: sortedCatalogEvents[nextIndex].event.dates.start,
        },
      ];
    },
    [] as AllocatePlaceholderEventRequest[]
  );
};
